<main id="main" class="about-template">
    <!-- <div class="jumbotron jumbotron-fluid m-0 bg-yellow">
        <div class="container">
            <div class="row py-2 justify-content-center align-items-center">
                <div class="col">
                    <h1 class="row justify-content-center align-items-center bold">TRAC National Rally 2024
                        <span class="ml-4"><img src="./assets/images/media/Trac%20Events%20Page%20Icon-01.png" style="height: 100px; width: auto" alt="Events"></span>
                    </h1>
                </div>
            </div>
        </div>
    </div> -->
    <!-- <div class="jumbotron jumbotron-fluid m-0 image-cover" style="background-image: url('./assets/images/media/rally2024/TRAC-Banner-Rally2024.webp?v=20241112');"> -->
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="col-sm-12 px-0">
                    <img src="./assets/images/media/elands2025/elands2025-banner.webp?v=20250116" style="height: auto; width: auto" alt="Elands 2025">
                </div>
                <!-- <img src="./assets/images/media/rally2024/trac-rally-badge-2024.webp?v20240710" style="height: 200px; width: auto" alt="Trac Rally 2024"> -->
                <!-- <img src="./assets/images/home-tiles/trac-rally-2024-banner.webp?v20240710" style="width: auto" alt="Trac Rally 2024"> -->
            </div>
        </div>
    <!-- </div> -->
    <div class="container">
        <div class="row">
            <div class="col-sm-12 text-center my-5">
                <div class="removeMarginOnSmallScreensSpectatorGuide">
                    <h3 class="text-uppercase mb-5">TRACN4 ELANDS MARATHON 2024</h3>
                    <iframe width="100%" height="500" src="https://www.youtube.com/embed/3dFUHoSYtHk?si=7eVF5XlLU95STsZT"
                        title="YouTube video player" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
                </div>
            </div>
        </div>
        <!-- <div class="row mb-4">
            <div class="col-sm-6">
                <iframe width="100%" height="320" src="https://www.youtube.com/embed/F8yZGJLaNLs"
                        title="YouTube video player" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
            </div>
            <div class="col-sm-6">
                <iframe width="100%" height="320" src="https://www.youtube.com/embed/hJ7Txc5aoZY?si=-U2KDSikdrtjGBjg"
                        title="YouTube video player" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
            </div>
        </div>
        <div class="row mb-5">
            <div class="col-sm-6">
                <iframe width="100%" height="320" src="https://www.youtube.com/embed/-g1nLofP19g?si=o5wag4Pit3LEcYo8"
                        title="YouTube video player" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
            </div>
            <div class="col-sm-6">
                <iframe width="100%" height="320" src="https://www.youtube.com/embed/TYtHIMsbV_k?si=IfVnKbmoz20YO3iI"
                        title="YouTube video player" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
            </div>
        </div> -->
    </div>
    <div class="container-fluid" style="background-color: #2020200a;">
        <div class="container">
            <div class="row">
                <div class="col-sm-12 text-center mt-5">
                    <div class="removeMarginOnSmallScreensSpectatorGuide">
                        <h3 class="text-uppercase">TRACN4 ELANDS MARATHON 2025 GALLERY</h3>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 mt-3 mb-3 text-center p-0" style="display: flex; flex-direction: column;">
                    <!-- <span>{{imageCounter}} / 126</span> -->
                    <div *ngIf="imageListVarExt === 'webp'">
                        <img [src]="imageListVar" style="height:100%;" class="img-fluid d-block mx-auto rounded" alt="Elands 2024"/>
                    </div>
                    <div *ngIf="imageListVarExt === 'mp4'">
                        <video controls preload="none" poster="" class="playvid">
                            <source [src]="imageListVar" type="video/mp4">
                        </video>
                    </div>
                    <!-- <img [src]="imageListVar" style="height:100%;" class="img-fluid d-block mx-auto rounded" alt="Elands 2024"/> -->
                    <button
                            class="slider-btn slider-btn-left"
                            (click)="previousImage()">&larr;
                    </button>
                    <button class="slider-btn slider-btn-right" (click)="nextImage()">&rarr;
                    </button>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-4 col-md-3 px-1 py-1" *ngFor="let img of this.elandsimages;  index as i">
                    <!-- <div [attr.id]="i" class="" style="background-image: url('{{img.url}}'); width: 100%; height: 150px; background-size: cover; background-position: center;" (click)="imageSelected($event)">
                        <img src="{{img.url}}" height="150" />
                    </div> -->
                    <div *ngIf="img.ext == 'webp'">
                        <div [attr.id]="i" class="" style="width: 100%; height: 150px; position:relative;">
                            <img ngSrc="{{img.url}}?v=20250307" fill/>
                            <div [attr.id]="i" class="position-absolute" style="width: 100%; height: 100%" (click)="imageSelected($event)" [attr.data-url]="img.url"></div>
                        </div>
                    </div>                    
                    <div *ngIf="img.ext == 'mp4'">
                        <div [attr.id]="i" class="" style="width: 100%; height: 150px; position:relative;">
                            <div [attr.id]="i" class="" style="width: 100%; height: 150px; position:relative;">
                                <img ngSrc="{{img.thumb}}?v=20250307" fill/>
                                <div [attr.id]="i" class="position-absolute" style="width: 100%; height: 100%" (click)="imageSelected($event)" [attr.data-url]="img.url"></div>
                            </div>
                        </div>
                    </div>                    
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col text-center py-3 mt-2">
                <a class="actionlink abutton" href="" routerLink="/gallery/elands-marathon-2025">View Full Gallery</a>
            </div>
        </div>
        <br/>
    </div>
    <div class="container-fluid">
        <div class="row py-3">
            <div class="col-sm-12">
                <div class="container  ">
                    <div class="col-sm-12 col-lg-12 white-text mt-5 my-3 p-0">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="mt-3 mb-3 black-text">
                                    <div class="removeMarginOnSmallScreensSpectatorGuide text-left">
                                        <h3 class="text-uppercase">Step Into Excellence at the TRACN4 Elands Marathon 2025!</h3>
                                        <p>Mark your calendar for 1 March 2025, and get ready for an unforgettable experience of endurance and camaraderie. Whether you’re conquering the 42.2km, 21.1km, or 10km race, our scenic routes promise to inspire and challenge you.</p>
                                        <p>As you push your limits and celebrate personal milestones, don’t forget the added bonus—participants earn Vitality points, making this not just a race but a step toward greater well-being.<br>
                                            Join us for a day of fitness, achievement, and vitality at the TRACN4 Elands Marathon 2025!</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6" style="text-align: center;">
                                <!-- <img src="./assets/images/media/rally2024/trac-rally-artwork-2024.webp?v20240710" alt="2024 TRACN4 National Rally Programme" class="img-fluid"/> -->
                                <img src="./assets/images/media/elands2025/Trac-Elands-Marathon-logo.webp?v20250116" style="width: 60%; margin: auto;" alt="2024 TRACN4 National Rally Programme" class="img-fluid"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid" style="background-color: #f7f7f7;">
        <div class="row">
            <div class="col-sm-12 text-center mt-5">
                <div class="removeMarginOnSmallScreensSpectatorGuide">
                    <h3 class="text-uppercase">TRACN4 Elands Marathon Race Shirt 2025</h3>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 mt-3 mb-3 text-center" style="display: flex; flex-direction: column;">
                <img class="text-center" src="./assets/images/media/elands2025/elands-2025-shirt.webp?v=20250116" style="height: auto; width: 70%; margin: 0 auto;" alt="Elands 2025">
            </div>
        </div>
    </div>
    <div class="container-fluid" style="background-color: #f7f7f7;">
        <div class="row">
            <div class="col-sm-12 text-center mt-5">
                <div class="removeMarginOnSmallScreensSpectatorGuide">
                    <h3 class="text-uppercase">RACE PROFILE</h3>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 mt-3 mb-3 text-center" style="display: flex; flex-direction: column;">
                <img class="text-center" src="./assets/images/media/elands2025/elands-2025-raceprofile.webp?v=20250116" style="height: auto; width: 70%; margin: 0 auto;" alt="Elands 2025">
            </div>
        </div>
    </div>
    <div class="container-fluid" style="background-color: #f7f7f7;">
        <div class="row">
            <div class="col-sm-12 text-center mt-5">
                <div class="removeMarginOnSmallScreensSpectatorGuide">
                    <h3 class="text-uppercase">Qualifier</h3>
                </div>
            </div>
        </div>
        <div class="row justify-content-center" style="text-align : center;">
            <div class="col-sm-3 col-md-3 mb-3 ">
                <img src="./assets/images/media/elands2025/two-oceans.webp?v=20250116" alt="" style="width: 80%;">
            </div>
            <div class="col-sm-3 col-md-3 mb-3">
                <img src="./assets/images/media/elands2025/comrades.webp?v=20250116" alt="" style="width: 80%;">
            </div>
        </div>
    </div>
    <div class="container" style="background-color: #fff;">
        <div class="row">
            <div class="col-sm-12 text-center mt-5">
                <div class="removeMarginOnSmallScreensSpectatorGuide">
                    <h3 class="text-uppercase">PARTNERS</h3>
                </div>
            </div>
        </div>
        <div class="row justify-content-center" style="text-align : center;">
            <div class="col-sm-3 col-md-3 mb-3 ">
                <img src="./assets/images/media/elands2025/tracn4-elands.webp?v=20250116" alt="" style="width: 80%;">
            </div>
            <div class="col-sm-3 col-md-3 mb-3">
                <img src="./assets/images/media/elands2025/LVCC.webp?v=20250116" alt="" style="width: 80%;">
            </div>
            <div class="col-sm-3 col-md-3 mb-3">
                <img src="./assets/images/media/elands2025/nedbank.webp?v=20250116" alt="" style="width: 80%;">
            </div>
            <div class="col-sm-3 col-md-3 mb-3">
                <img src="./assets/images/media/elands2025/astron.webp?v=20250116" alt="" style="width: 80%;">
            </div>
        </div>
        <div class="row justify-content-center" style="text-align : center;">
            <div class="col-sm-3 col-md-3 mb-3 ">
                <img src="./assets/images/media/elands2025/millys.webp?v=20250116" alt="" style="width: 80%;">
            </div>
            <div class="col-sm-3 col-md-3 mb-3">
                <img src="./assets/images/media/elands2025/buscor.webp?v=20250116" alt="" style="width: 80%;">
            </div>
            <div class="col-sm-3 col-md-3 mb-3">
                <img src="./assets/images/media/elands2025/risefm.webp?v=20250116" alt="" style="width: 80%;">
            </div>
            <div class="col-sm-3 col-md-3 mb-3">
                <img src="./assets/images/media/elands2025/motus.webp?v=20250116" alt="" style="width: 80%;">
            </div>
        </div>
        <div class="row justify-content-center" style="text-align : center;">
            <div class="col-sm-3 col-md-3 mb-3 ">
                <img src="./assets/images/media/elands2025/coastal-hire.webp?v=20250116" alt="" style="width: 80%;">
            </div>
            <div class="col-sm-3 col-md-3 mb-3">
                <img src="./assets/images/media/elands2025/bigsky.webp?v=20250116" alt="" style="width: 80%;">
            </div>
            <div class="col-sm-3 col-md-3 mb-3">
                <img src="./assets/images/media/elands2025/comrades.webp?v=20250116" alt="" style="width: 80%;">
            </div>
            <div class="col-sm-3 col-md-3 mb-3">
                <img src="./assets/images/media/elands2025/two-oceans.webp?v=20250116" alt="" style="width: 80%;">
            </div>
        </div>
    </div>
    <!-- <div class="container-fluid" style="background-color: #000; height: 40px;"></div> -->
    <div class="container">
        <div id="relatedlinkstolls" class="row pt-5">
            <div class="col-sm-12 col-md-12 text-center">
                <h3 class="text-uppercase">Related Links</h3>
            </div>
        </div>
        <div id="" class="row pb-5 related-blocks mx-sm-1">
            <div class="col-sm-12 col-md text-center p-0 mb-2"></div>
            <div class="col-sm-12 col-md text-center block-bg-yellow p-0 mb-2 mx-0 mx-md-5">
                <a class="actionlink p-0" href="" routerLink="/pressreleases">
                    <div class="p-3 related-block-content block-content-reverse">
                        <div class="cta-img d-flex justify-content-center align-items-start" style="height: 280px;">
                            <img class="" src="./assets/images/icons/press-release-icon.png?v=20250117" style="height: 150px; position: absolute;" alt="Press">
                            <div class="related-block-content-headings">
                                <h5 class="mt-3 mb-0 black-text">Press Releasees</h5>
                                <h6 class="mt-2 black-text">Find out more</h6>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-sm-12 col-md text-center p-0"></div>
        </div>
    </div>
    <!-- <div class="header  bg-yellow py-4">
        <h3 class="text-center text-black bold">PRESS RELEASES 2024</h3>
    </div>
    <div class="container">
        <div class="row" *ngIf="requestFailed">
            <div class="col-sm-12 col-md-12 py-4">
                <div class="post-title">
                    <h5 class="mb-0 bold text-center">
                        No Current Press Releases
                    </h5>
                </div>
            </div>
        </div>
        <div class="row py-4" *ngIf="this.apiContent !== ''">
            <ng-container *ngFor="let o of this.apiContent.body?.Data;  index as i ">
                <div *ngIf="o.Date>='2024-01-01'" class="col-sm-6 col-md-6 py-4">
                    <div class="post-title">
                        <h2 class="posttitle mb-0 bold"><span
                                class="posttitledate mr-2">{{o.Date | date:'dd MMMM'}}</span>{{o.Name}}</h2></div>
                    <div class="post-summary"><p class="float-left w-100 ">{{o.Introduction}}</p>
                        <a class="h6" routerLink="/readmoretracevents/{{o.ID}}/{{i}}">Read More</a></div>
                </div>
            </ng-container>
        </div>
    </div> -->
    <!-- <div class="header  bg-yellow py-4">
        <h3 class="text-center text-black bold">PRESS RELEASES 2019 - 2023</h3>
    </div>
    <div class="container">
        <div class="row" *ngIf="requestFailed">
            <div class="col-sm-12 col-md-12 py-4">
                <div class="post-title">
                    <h5 class="mb-0 bold text-center">
                        No Current Press Releases
                    </h5>
                </div>
            </div>
        </div>
        <div class="row py-4" *ngIf="this.apiContent !== ''">
            <ng-container *ngFor="let o of this.apiContent.body?.Data;  index as i ">
                <div *ngIf="o.Date<='2023-12-31'" class="col-sm-6 col-md-6 py-4">
                    <div class="post-title">
                        <h2 class="posttitle mb-0 bold"><span
                                class="posttitledate mr-2">{{o.Date | date:'dd MMMM'}}</span>{{o.Name}}</h2></div>
                    <div class="post-summary"><p class="float-left w-100 ">{{o.Introduction}}</p>
                        <a class="h6" routerLink="/readmoretracevents/{{o.ID}}/{{i}}">Read More</a></div>
                </div>
            </ng-container>
        </div>
    </div> -->
</main>

<ng-template #popup let-modal class="slider-popup">
    <div class="slider-popup">
    <div class="modal-header" style="position: absolute; z-index: 9; right: 0; border: none;">
        <button type="button" class="btn btn-outline-light" (click)="modal.close('close click')">Close</button>
    </div>
    <div class="modal-body">
        <img [src]="imageListVar2"
             class="img-fluid"
             style=" width: 100%; max-width:100%; height:auto; "/>
        <div class="col-sm-12 position-absolute" style="top: 50%;">
            <div>
                <button
                        class="btn black-text shadow bg-yellow fontsize13m text-center p-2"
                        (click)="previousImageRes()" style="width:60px;">&larr;
                </button>
                <button class="btn black-text shadow bg-yellow fontsize13m text-center p-2"
                        (click)="nextImageHighRes()" style="width:60px; position: absolute; right: 15px;">&rarr;
                </button>
            </div>
        </div>
    </div>
    </div>
</ng-template>